// Egasi topshirig'i (2026-08-31): DARK MODE — best-practice.
// Rejimlar: 'light' | 'dark' | 'system' (standart: system — qurilma sozlamasiga
// ergashadi). Tanlov localStorage'da; amaldagi tema <html data-theme="..."> ga
// yoziladi va antd'ning dark CSS'i <link> orqali ulanadi/uziladi (flash'siz —
// init ilova renderidan OLDIN chaqiriladi).
export type ThemeMode = "light" | "dark" | "system"

const KEY = "ui_theme"
const LINK_ID = "antd-dark-css"

export function getThemeMode(): ThemeMode {
  try {
    const v = localStorage.getItem(KEY)
    if (v === "light" || v === "dark" || v === "system") return v
  } catch {}
  return "system"
}

function systemPrefersDark(): boolean {
  try {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
  } catch {
    return false
  }
}

export function effectiveTheme(mode: ThemeMode = getThemeMode()): "light" | "dark" {
  return mode === "system" ? (systemPrefersDark() ? "dark" : "light") : mode
}

function applyEffective(theme: "light" | "dark") {
  const root = document.documentElement
  root.setAttribute("data-theme", theme)

  // v3 (2026-08-31): Telegram-palitrali dark. Baza — antd'ning rasmiy dark CSS'i
  // (barcha kontrollar), ustidan index.less'dagi Telegram ranglari qo'llanadi.
  let link = document.getElementById(LINK_ID) as HTMLLinkElement | null
  if (theme === "dark") {
    if (!link) {
      link = document.createElement("link")
      link.id = LINK_ID
      link.rel = "stylesheet"
      link.href = (process.env.PUBLIC_URL || "") + "/antd-dark.min.css"
      document.head.appendChild(link)
    }
  } else if (link) {
    link.remove()
  }
}

export function setThemeMode(mode: ThemeMode) {
  try {
    localStorage.setItem(KEY, mode)
  } catch {}
  applyEffective(effectiveTheme(mode))
}

/** Ilova ochilishida BIR MARTA — React renderidan oldin (flash bo'lmasin) */
export function initTheme() {
  applyEffective(effectiveTheme())
  // 'system' rejimida qurilma temasi o'zgarsa jonli ergashamiz
  try {
    const mq = window.matchMedia("(prefers-color-scheme: dark)")
    const onChange = () => {
      if (getThemeMode() === "system") applyEffective(effectiveTheme("system"))
    }
    if (mq.addEventListener) mq.addEventListener("change", onChange)
    else if ((mq as any).addListener) (mq as any).addListener(onChange)
  } catch {}
}
